import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';

export const ArticleCard = ({ article, featured = false }) => {
  const formattedDate = new Date(article.date || article.created_at).toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const articleId = article._id || article.id;
  const categoryName = article.category_name || article.categoryName;

  if (featured) {
    return (
      <Link to={`/articulo/${article.slug}`}>
        <Card className="overflow-hidden hover:shadow-xl transition-shadow duration-300 group h-full">
          <div className="relative h-80 overflow-hidden">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
              <Badge className="bg-teal-500 hover:bg-teal-600 mb-3">
                {categoryName}
              </Badge>
              <h3 className="text-2xl font-bold mb-2 line-clamp-2 group-hover:text-teal-300 transition-colors">
                {article.title}
              </h3>
              <p className="text-gray-200 text-sm mb-3 line-clamp-2">
                {article.excerpt}
              </p>
              <div className="flex items-center space-x-4 text-xs text-gray-300">
                <div className="flex items-center space-x-1">
                  <Calendar className="h-3 w-3" />
                  <span>{formattedDate}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Clock className="h-3 w-3" />
                  <span>{article.read_time || article.readTime}</span>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </Link>
    );
  }

  return (
    <Link to={`/articulo/${article.slug}`}>
      <Card className="overflow-hidden hover:shadow-lg transition-all duration-300 group h-full flex flex-col">
        <div className="relative h-48 overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <Badge className="absolute top-3 left-3 bg-teal-500 hover:bg-teal-600">
            {categoryName}
          </Badge>
        </div>
        <CardContent className="p-5 flex-1 flex flex-col">
          <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-teal-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-gray-600 text-sm mb-4 line-clamp-3 flex-1">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-gray-500 pt-3 border-t border-gray-100">
            <div className="flex items-center space-x-3">
              <div className="flex items-center space-x-1">
                <Calendar className="h-3 w-3" />
                <span>{formattedDate}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Clock className="h-3 w-3" />
                <span>{article.read_time || article.readTime}</span>
              </div>
            </div>
            <ArrowRight className="h-4 w-4 text-teal-500 group-hover:translate-x-1 transition-transform" />
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};
